import {
    SelectedItems,
    SelectedItemsThreadPositionEnum,
    KINTEKI, ENTEKI, MAKIWARA, FULL, SEMI,
    ArrowTypeAPI,
    OrderTypeAPI,
} from '@app/react/const/type';
import type {
    DesignSet,
    ArrowType,
    OrderType,
    SelectedItemsCarving,
    SelectedItemsFamilycrest,
} from '@app/react/const/type';

export type PostSelectedItems = {
    [key in keyof Required<SelectedItems>]: Required<SelectedItems>[key] | null;
};

export const conv = (parts: DesignSet): PostSelectedItems => {
    const carving = ((): SelectedItemsCarving | null => {
        if (parts.carving === null) {
            return null;
        }
        return {
            id: parts.carving.id,
            name: parts.carvingString || '',
        };
    })();

    const familycrest = ((): SelectedItemsFamilycrest | null => {
        if (
            parts.familycrest === null
            || parts.familycrestColor === null
        ) {
            return null;
        }
        return {
            id: parts.familycrest.id,
            color: parts.familycrestColor.id,
        };
    })();

    const ret: PostSelectedItems = {
        /**
         * シャフトのID
         * @type {number}
         * @memberof SelectedItems
         */
        shaft: parts.shaft?.id || null,
        /**
         * 羽根のID
         * @type {number}
         * @memberof SelectedItems
         */
        feather: parts.feather?.id || null,
        /**
         * 糸・和紙のID
         * @type {number}
         * @memberof SelectedItems
         */
        thread: parts.thread?.id || null,
        /**
         * 毛引きのID
         * @type {number}
         * @memberof SelectedItems
         */
        kebiki: parts.kebiki?.id || null,
        /**
         * 矢筈のID
         * @type {number}
         * @memberof SelectedItems
         */
        nock: parts.nock?.id || null,
        /**
         * 矢尻のID
         * @type {number}
         * @memberof SelectedItems
         */
        arrowhead: parts.arrowhead?.id || null,
        /**
         * 矢尺のID
         * @type {number}
         * @memberof SelectedItems
         */
        arrowlength: parts.arrowlength?.id || null,
        /**
         * 本数のID
         * @type {number}
         * @memberof SelectedItems
         */
        unit: parts.unit?.id || null,
        /**
         * インサートのID
         * @type {number}
         * @memberof SelectedItems
         */
        arrowinsert: parts.arrowinsert?.id || null,
        /**
         * 筈巻のID
         * @type {number}
         * @memberof SelectedItems
         */
        twine: parts.twine?.id || null,
        /**
         * ラメのID
         * @type {number}
         * @memberof SelectedItems
         */
        lame: parts.lame?.id || null,
        /**
         *
         * @type {SelectedItemsCarving}
         * @memberof SelectedItems
         */
        carving,
        /**
         *
         * @type {SelectedItemsFamilycrest}
         * @memberof SelectedItems
         */
        familycrest,
        /**
         * 羽中文字のID
         * @type {number}
         * @memberof SelectedItems
         */
        featherinside: parts.featherinside?.id || null,
        /**
         * プチデコレーションのID
         * @type {number}
         * @memberof SelectedItems
         */
        decoration: parts.decoration?.id || null,
        /**
         * ZERO流のID
         * @type {number}
         * @memberof SelectedItems
         */
        typezero: parts.typezero?.id || null,
        /**
         * 糸・和紙のツヤ。true=ツヤあり、false=ツヤなし
         * @type {boolean}
         * @memberof SelectedItems
         */
        threadgloss: parts.threadGloss,
        /**
         * 羽根無し時の糸・和紙の場所 * `uraari` - 末矧あり * `uranashi` - 末矧なし
         * @type {string}
         * @memberof SelectedItems
         */
        threadPosition: parts.threadMode === 'ari'
            ? SelectedItemsThreadPositionEnum.Uraari
            : SelectedItemsThreadPositionEnum.Uranashi,
    };

    const keys = Object.keys(ret) as (keyof SelectedItems)[];
    keys.forEach((key) => {
        if (ret[key] === undefined) {
            delete ret[key];
        }
    });
    return ret;
};

export const convArrowType = (arrowType: ArrowType): ArrowTypeAPI => {
    switch (arrowType) {
        case KINTEKI:
            return ArrowTypeAPI.Kinteki;
        case ENTEKI:
            return ArrowTypeAPI.Enteki;
        case MAKIWARA:
            return ArrowTypeAPI.Makiwara;
        default:
            break;
    }

    const msg = 'type convert to ArrowTypeAPI from ArrowType';
    throw new Error(msg);
};

export const convOrderType = (orderType: OrderType): OrderTypeAPI => {
    switch (orderType) {
        case FULL:
            return OrderTypeAPI.Full;
        case SEMI:
            return OrderTypeAPI.Semi;
        default:
            break;
    }

    const msg = 'type convert to OrderTypeAPI from OrderType:';
    throw new Error(msg);
};
